import { render, staticRenderFns } from "./interview-quiz-list.html?vue&type=template&id=1896c0d4&scoped=true&"
import script from "./interview-quiz-list.js?vue&type=script&lang=js&"
export * from "./interview-quiz-list.js?vue&type=script&lang=js&"
import style0 from "./interview-quiz-list.scss?vue&type=style&index=0&id=1896c0d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896c0d4",
  null
  
)

export default component.exports